import Axios from 'axios'
import Servers from "../../server"
export default{
    state: {
      deviceObject: {},
      listOfParents:[],
      edit: false,
    },
    mutations: {
        setDevice(state, obj){
            state.deviceObject = obj;
        },
        setListOfParents(state, obj){
            state.listOfParents = obj;
        }
    },
    getters: {
        getDevice(state){
            return state.deviceObject;
        }
    },
    actions: {
        async getAllDevices(){
         return await Axios.get(Servers.serverApi+"api/devices/", {
                responseType: "application/json",
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token")
                }
              });
        },
        async postDevice(context, body){
            let response = await Axios.post(Servers.serverApi+"api/devices/", body,{
                responseType: "application/json",
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            })
            return response

        },
        async getDeviceInfo(context, uuid){
            let response = await Axios.get(Servers.serverApi+"api/devices/"+uuid, {
                responseType: "application/json",
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            })

            context.commit("setDevice", response.data.data);
            return response;
        },
        async getParentDevices(context, uuid){
            let response = await Axios.get(Servers.serverApi+"api/devices/searchParentDevice/"+uuid, {
                responseType: "application/json",
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            });
            return response;
            
        },
        async editDevice(context, data){
            let response = await Axios.put(Servers.serverApi + "api/devices/" + data.uuid, data.body, {
                    responseType: "application/json",
                    headers: {
                      Authorization: "Bearer " + localStorage.getItem("access_token"),
                    },
                  })
            return response
        }


    }
}